module.exports = __webpack_public_path__ + "static/media/19.602d60a1.jpg";